<template>
  <MegamenuTransition>
    <div
      v-show="openedMenuId === data.id"
      :id="`${megamenuId}--${data.id}`"
      class="col-12 c-pt-3 c-pl-2 c-sm:c-pl-4 megamenu__child"
      :class="`megamenu__child--${data.id}`"
      @mouseleave="mouseleave"
    >
      <div class="megamenu__child__inner c-p-3 c-sm:c-p-4">
        <Items
          v-if="data.id !== 'club'"
          :id="data.id"
          :items="data.items"
        />
        <ItemsClub
          v-else
          :items="data.items"
        />
      </div>
    </div>
  </MegamenuTransition>
</template>

<script setup>
import ItemsClub from './TheMegamenuChildClubItems.vue'
import Items from './TheMegamenuChildItems.vue'
import MegamenuTransition from './TheMegamenuChildTransition.vue'

const props = defineProps({
  openedMenuId: {
    type: String,
    default: undefined,
  },

  megamenuId: {
    type: String,
    default: 'megamenu--secondary',
  },

  hideSubmenu: {
    type: Function,
    required: true,
  },

  data: {
    type: Object,
    default() {
      return {
        id: {
          type: String,
          validator: (value) => {
            return ['mix', 'ready', 'club'].includes(value)
          },
        },

        items: {
          type: Array,
        },
      }
    },
  },
})

const mouseleave = (event) => {
  if (window.innerWidth >= 992 && event.relatedTarget && !event.relatedTarget.closest('.megamenu__link')) {
    props.hideSubmenu(props.data.id)
  }
}
</script>
